import React from 'react'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const BaseModal = ({ isOpen, toggleModal, title, message, icon, href, linkText, showCloseButton = true }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleButtonClick = () => {
    if (href) {
      if (href.startsWith('http')) {
        window.open(href, '_blank', 'noopener,noreferrer')
      } else {
        navigate(href)
      }
    } else {
      toggleModal()
    }
  }

  return (
    <Modal isOpen={isOpen.keyCode === 27 ? false : isOpen} toggle={toggleModal} zIndex={9999}>
      {showCloseButton && (
        <ModalHeader toggle={toggleModal} className="border-0" />
      )}
      <ModalBody className="modal-body-lg text-center pt-0">
        <div className="nk-modal">
          {icon}
          <h4 className="nk-modal-title">{title}</h4>
          <div className="nk-modal-text">
            <p className="lead">
              {message}
            </p>
          </div>
          <div className="nk-modal-action mt-5 d-flex justify-content-center gap-2">
            <Button color="light" size="lg" className="btn-mw" onClick={toggleModal}>
              {t('common.cancel')}
            </Button>
            {href && (
              <Button color="primary" size="lg" className="btn-mw" onClick={handleButtonClick}>
                {linkText || t('return')}
              </Button>
            )}
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default BaseModal
